import { Injectable } from '@nestjs/common';
import { Repository } from 'typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { InjectRepository } from '@nestjs/typeorm';
import { CalibrationResponseModel, CalibrationReq, ExpensesResponse, AllCalibrationResponseModel } from '@gtpl/shared-models/hrms';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { Calibrations } from './calibration.entity';
import { CalibrationAdapter } from './dto/calibrations.adapter';
import { CalibrationDto } from './dto/calibration.dto';
import { CalibrationIdReq } from './dto/calibration.req';
import { CommonResponse } from '@gtpl/shared-models/production-management';
const fileDirectory = __dirname.replace(/\\dist/, '')
import path, { extname } from 'path'
import fs from 'fs'
import { CalibrationRepo } from './dto/calibration.repo';


@Injectable()
export class CalibrationService {

    constructor(
        private logService: LogsService,

        @InjectRepository(Calibrations)
        private repository: Repository<Calibrations>,
        private adapter: CalibrationAdapter,
        private repo :CalibrationRepo
    ) { }

    async getCalibration(calibrationid: number): Promise<Calibrations> {
        const response = await this.repository.findOne({
            where: { calibrationId: calibrationid },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async createCalibration(dto: CalibrationDto, isUpdate: boolean): Promise<CalibrationResponseModel> {
        try {
            if (!isUpdate) {
                const entity = await this.getCalibration(dto.calibrationId);
                if (entity) {
                    throw new ErrorResponse(11104, 'Calibrations data already exists');
                }
            } else {
                const entity = await this.getCalibration(dto.calibrationId);
                if (entity) {
                    if (entity.calibrationId != dto.calibrationId) {
                        throw new ErrorResponse(11104, 'Calibrations data already exists');
                    }
                }
            }

            const existingBarcode = await this.repository.findOne({ barcodeNo: dto.barcodeNo });
            if (existingBarcode && existingBarcode.calibrationId !== dto.calibrationId) {
                throw new ErrorResponse(11105, 'Barcode already exists');
            }


            const convertedDto: Calibrations = this.adapter.convertDtoToEntity(dto);
            const savedEntity: Calibrations = await this.repository.save(convertedDto);
            const savedDto: CalibrationDto = this.adapter.convertEntityToDto(savedEntity);
            if (savedDto) {
                const response = new CalibrationResponseModel(true, 1, isUpdate ? 'calibrations updated successfully' : 'calibrations created successfully', savedDto);
                const name = isUpdate ? 'updated' : 'created'

                const newLogDto = new LogsDto(1, name, 'calibrations', savedDto.calibrationId, true, '', savedDto.createdUser)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            } else {
                throw new ErrorResponse(11106, 'Calibrations data saved but there is an issue while converting it into DTO');
            }
        } catch (error) {
            throw error;
        }
    }

    // async getAllCalibrations(req:CalibrationIdReq): Promise<AllCalibrationResponseModel> {
    //     try {
    //         const dtos: CalibrationDto[] = [];
    //         const entities: Calibrations[] = await this.repository.find({ order: { calibrationId: 'DESC' },plant:req.plant });
    //         if (entities) {
    //             entities.forEach(entity => {
    //                 const Dto: Calibrations = this.adapter.convertEntityToDto(entity);
    //                 dtos.push(Dto);
    //             });
    //             const response = new AllCalibrationResponseModel(true, 1, 'calibrations Retrieved Successfully', dtos);
    //             const newLogDto = new LogsDto(1, 'view', 'Calibrations', 0, true, '', '')
    //             let res = await this.logService.createLog(newLogDto);
    //             console.log(res);
    //             return response;
    //         } else {
    //             throw new ErrorResponse(99998, 'Data Not Found');
    //         }
    //     } catch (error) {
    //         throw error;
    //     }
    // }
    async  getAllCalibrations(req:CalibrationIdReq): Promise<AllCalibrationResponseModel> {
        const ba: any = await this.repo.getAllCalibrations(req);
        return new AllCalibrationResponseModel(true, 123, 'retrieved successfully', ba);
    }


    // async getAllActiveCalibrations(): Promise<AllCalibrationResponseModel> {
    //     try {
    //         const dtos: CalibrationDto[] = [];
    //         const entities: Calibrations[] = await this.repository.find({ order: { calibrationId: 'ASC' }, where: { isActive: true } });
    //         if (entities && entities.length > 0) {
    //             entities.forEach(entity => {
    //                 const Dto: Calibrations = this.adapter.convertEntityToDto(entity);
    //                 dtos.push(Dto);
    //             });
    //             const response = new AllCalibrationResponseModel(true, 1, 'Certifications Retrieved Successfully', dtos);
    //             return response;
    //         } else {
    //             throw new ErrorResponse(99998, 'Data Not Found');
    //         }
    //     } catch (error) {
    //         throw error;
    //     }
    // }

    async getAllActiveCalibrations(): Promise<AllCalibrationResponseModel> {
        try {
            const dtos: CalibrationDto[] = [];
            const entities: Calibrations[] = await this.repository.find({
                order: { calibrationId: 'ASC' },
                where: { isActive: true },
            });
    
            if (entities && entities.length > 0) {
                entities.forEach((entity) => {
                    const Dto: CalibrationDto = this.adapter.convertEntityToDto(entity);
                    dtos.push(Dto);
                });
    
                const response = new AllCalibrationResponseModel(
                    true,
                    1,
                    'Certifications Retrieved Successfully',
                    dtos
                );
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (error) {
            throw error;
        }
    }

    async getCalibrationsById(id: number): Promise<Calibrations> {
        const response = await this.repository.findOne({
            where: { calibrationId: id },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async activateOrDeactivateCalibrations(req: CalibrationIdReq): Promise<CalibrationResponseModel> {
        try {
            const calibrationExists = await this.getCalibrationsById(req.calibrationId);
            if (calibrationExists) {
                if (req.versionFlag != calibrationExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updatedt the current calibration information. Refresh and try again');
                } else {
                    const expensesStatus = await this.repository.update(
                        { calibrationId: req.calibrationId },
                        { isActive: req.isActive, updatedUser: req.updatedUser },
                    );
                    if (calibrationExists.isActive) {
                        if (expensesStatus.affected) {
                            const response: CalibrationResponseModel = new CalibrationResponseModel(true, 10115, 'calibration is de-activated successfully');
                            return response;
                        } else {
                            throw new ErrorResponse(10111, 'calibration is already de-activated');
                        }
                    } else {
                        if (expensesStatus.affected) {
                            const response: CalibrationResponseModel = new CalibrationResponseModel(true, 10114, 'calibration is activated successfully');
                            return response;
                        } else {
                            throw new ErrorResponse(10112, 'calibration is already activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (error) {
            throw error;
        }
    }

    async getCalibrationById(req: CalibrationReq): Promise<CalibrationResponseModel> {
        try {
            const entity: Calibrations = await this.repository.findOne({ where: { certificationId: req.calibrationId } });
            if (entity) {
                const convertedEntity = this.adapter.convertEntityToDto(entity);
                const response: CalibrationResponseModel = new CalibrationResponseModel(true, 1, 'calibration found and retrieved', convertedEntity);
                return response;
            } else {
                throw new ErrorResponse(99998, "No Data Found");
            }
        } catch (error) {
            throw error;
        }
    }


    // async colabrationFileSave(file, req): Promise<CommonResponse> {
    //     const readingFilePath = path.join(fileDirectory, 'masters-upload-files', path.join(fileDirectory, '../../../', 'masters-upload-files'), '');
    //     try {
    //         const filePath = "upload-files"
    //         // + file.path.replace(path.join(fileDirectory, 'upload-files'), '')
    //         const upDateRepo = await this.repository.update({ calibrationId: req.id }, { filePath: file.filename })
    //         return new CommonResponse(true, 34569, "File Uploaded Successfully")

    //     } catch (error) {
    //         if (fs.existsSync(readingFilePath)) {
    //             fs.unlinkSync(readingFilePath)
    //         }
    //         return new CommonResponse(false, 9876, error.message)

    //     }
    // }

    async colabrationFileSave(filedata: any, req: any): Promise<CommonResponse> {
        try {
            console.log(filedata, 'Received file data for saving');
    
            // Find if there's already an entry for the given calibrationId
            let existingRecord = await this.repository.findOne({
                where: { calibrationId: req.calibrationId }
            });
    
            let newFilePaths = filedata.map(file => file.path).join(',');
            let newFileNames = filedata.map(file => file.filename).join(',');
    
            if (existingRecord) {
                // Append the new values to the existing ones
                if (existingRecord.filePath) {
                    existingRecord.filePath += ',' + newFilePaths;
                } else {
                    existingRecord.filePath = newFilePaths;
                }
    
                if (existingRecord.fileName) {
                    existingRecord.fileName += ',' + newFileNames;
                } else {
                    existingRecord.fileName = newFileNames;
                }
    
                // Save the updated record
                await this.repository.save(existingRecord);
            } else {
                // Create a new record
                const newRecord = this.repository.create({
                    calibrationId: req.calibrationId,
                    filePath: newFilePaths,
                    fileName: newFileNames,
                });
    
                await this.repository.save(newRecord);
            }
    
            return new CommonResponse(true, 1, 'Uploaded successfully', { fileNames: newFileNames, filePaths: newFilePaths });
        } catch (error) {
            console.error('Error occurred while saving file paths:', error);
            return new CommonResponse(false, 0, 'Upload failed due to an error', '');
        }
    }
    
                             

}
